<template>
  <v-content>
    <v-slide-y-transition
      mode="in-out"
      hide-on-leave>
      <v-flex 
        style=" max-width: 600px; margin: auto;"
        class="mt-4"
        xs12>
        <!-- TODO: Text/Translate -->

        <v-text-field
          v-model.lazy="search"
          
          autofocus
          single-line
          solo
          :append-icon="search ? 'fas fa-times' : ''"
          prepend-inner-icon="fas fa-search"
          label="Suche nach Name oder ID"
          @input="inputEventSearchFriends"
          @click:append="clearSearch">
        </v-text-field>
      </v-flex>
    </v-slide-y-transition>

   
    <v-card 
      v-if="validSearch"

      max-width="600" 
      style="margin: auto;">
      <v-layout 
        row 
        wrap>
        <v-flex 
          xs12>
          <v-list
            three-line>
            <template
              v-for="(item, index) in foundFriends">
              <!-- <v-divider
                  :key="index"
                  :inset="false">
                </v-divider> -->
              <!-- {{ myFriends }}
              {{ myFriends.some(friend => friend.id === item.id) }} -->
              <v-list-tile
                v-if="item.name.toUpperCase().includes(search.toUpperCase()) || item.uniqueId.includes(search.toLowerCase())"
                :key="index"
                avatar
                :to="'/profile/' + item.uniqueId"
                @click.prevent="">
                <v-list-tile-avatar style="margin: auto">
                  <img :src="item.profileImg">
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ item.name }}
                  </v-list-tile-title>
                  <span class="ml-1 caption grey--text font-italic">
                    <v-icon size="14">
                      fas fa-fingerprint
                    </v-icon> {{ item.uniqueId }}
                  </span>
                  <v-list-tile-sub-title 
                    style="overflow: hidden; white-space: nowrap;" 
                    class="caption font-italic">
                    {{ item.status }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <!-- item.id: {{ item.id }}
                {{ myFriends.some(friend => friend.friendId !== item.id) }} -->
                <v-list-tile-action @click.prevent="">
                  <app-buttons-friend-request
                    :item="item"
                    :my-friends="myFriends"
                    :user="user"></app-buttons-friend-request>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list>
        </v-flex>
      </v-layout>
    </v-card>
    
    <v-hover v-else>
      <v-card
        slot-scope="{ hover }"
        class="mt-5 py-5 roundedcard"
        :class="`elevation-${hover ? 20 : 12}`"
        style="width: 300px; margin: auto;">
        <v-card-text class="my-5">
          <v-layout 
            row 
            wrap>
            <v-flex
              xs12>
              <!-- <v-flex class="text-xs-center">
              <span class="headline">
                Nix los
              </span>
            </v-flex> -->

              <v-flex class="mt-2 text-xs-center">
                <v-icon
                  color="secondary"
                  size="100">
                  far fa-theater-masks
                </v-icon>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-hover>
  </v-content>
</template>


<script>
import { debounce } from 'lodash'
import { mapState, mapMutations, mapActions } from 'vuex'


import ButtonsFriendRequestSearch from '@/components/global_comps/FriendRequest/ButtonsFriendRequestSearch.vue'

export default {
  components: {
    // eslint-disable-next-line
    "app-buttons-friend-request": ButtonsFriendRequestSearch
  },
  data() {
    return {
      search: '',
      searchArray: []
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.user,
      path: state => state.route.path,
      isMobile: state => state.isMobile,
      foundFriends: state => state.friends.foundFriends,
      searchActive: state => state.searchActive,
      myFriends: state => state.user.myFriends
    }),


    // Suchergebnisse nur anzeigen, wenn alle Kriterien "valid" sind
    validSearch () {
      if (this.searchActive && this.foundFriends.length !== 0 && this.search && this.search.length >= 3) {
        if (this.foundFriends.some(obj => obj.name.toUpperCase().includes(this.search.toUpperCase())) || this.foundFriends.some(obj => obj.uniqueId.toLowerCase().includes(this.search.toLowerCase()))) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    debouncedSearch () {
      // console.log('I only get fired once every two seconds, max!')
      return debounce(this.getFriends, 200)
    },
    
  },

  destroyed () {
    this.deactivateSearch(false)
  },

  methods: {
    ...mapMutations([
      'searchActivated',
      'deactivateSearch',
      'delFoundFriends',
    ]),
    ...mapActions([
      'searchNewFriends',
      'searchNewFriendsUniqueId',
    ]),

    clearSearch () {
      // this.delFoundFriends()
      this.search = ''
    },

    
    
    // write search terms in search Array and debounce requests
    inputEventSearchFriends () {
      // fill searchArray only with NEW search Terms
      if (this.searchArray.some(obj => obj === this.search.toUpperCase())) {
        // Do nothing
      } else {
        this.searchArray.push(this.search.toUpperCase())
        // onlySearch for new Friends, if search Terms are new
        this.debouncedSearch()
      }      
    },

    // search Friends in DB
    getFriends () {
      // this.delFoundFriends()

      if (this.search && this.search.length >= 3) {
        // TODO
        // Wenn Freund bereits in meiner Freundesliste ist, dann getrennt anzeigen (zwischenüberschrift: Freunde)

        
        // console.log('neuer DB zugriff')
 
        this.searchNewFriends(this.search)
        this.searchNewFriendsUniqueId(this.search)
      } else  {
        

      }
    },

    
  }
}
</script>
